"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
const menuButtons_1 = require("../models/menuButtons");
const lists_1 = require("../models/lists");
class Activites extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "activites",
            datatableName: "activitesdatatable",
            columns: [
                {
                    id: "unid", header: (0, globals_1._)("N°"), width: 40,
                    css: { "text-align": "right" }, sort: "int", hidden: false
                },
                { id: "type", editor: "combo", header: (0, globals_1._)("Type activité"),
                    width: "150",
                    value: "Marche Nordique",
                    options: lists_1.typesActivitesList,
                },
                { id: "numLigne", editor: "text", header: "Ligne",
                    css: { "text-align": "right" }, width: 60, sort: "integer" },
                { id: "date", editor: "date", header: "Date / heure", width: 150, format: webix.Date.dateToStr("%Y-%m-%d %H:%i"),
                    template(obj, type, value) {
                        // locale-based date format
                        return value ? webix.i18n.dateFormatStr(value) + "   " + webix.i18n.timeFormatStr(value) : "";
                    },
                    popup: {
                        view: "popup", width: 250, height: 250, padding: 0,
                        body: {
                            view: "calendar",
                            timepicker: true,
                            borderless: true,
                            on: {
                                onAfterDateSelect(date) {
                                    webix.callEvent("onEditEnd", [date]);
                                }
                            }
                        }
                    }
                },
                { id: "lieu", editor: "text", maxlength: 36,
                    header: (0, globals_1._)("Lieu"), width: 200, sort: "text" },
                { id: "animateur", editor: "text", header: (0, globals_1._)("Animateur"), width: 200, sort: "text",
                    maxlength: 20 },
                { id: "vitesse", editor: "text", header: (0, globals_1._)("Niveau"), width: 140, sort: "text",
                    maxlength: 18 }
            ],
            title: (0, globals_1._)("Activités"),
            boutons: [menuButtons_1.ajouterButton, menuButtons_1.supprimerButton],
            multiselect: false,
            resizeColumn: true,
            urlData: globals_1.phpPath + "activites.php?option=list",
            saveData: {
                updateFromResponse: true,
                "insert": globals_1.phpPath + "activites.php?option=create",
                "update": globals_1.phpPath + "activites.php?option=update",
                "delete": globals_1.phpPath + "activites.php?option=delete",
            }
            // rules : {
            // 	// email : webix.rules.isEmail		//	Supprimé, car bloque l'enregistrement et donc les valeurs par défaut
            // }
        });
        // @ts-ignore
        // private defaultValues = { };
        this.firstFocusField = "type";
    }
    setDefaultValues(record) {
        let dtable = this.currentGrid;
        // if (this.defaultValues) {
        // 	dtable.updateItem(record.id,this.defaultValues);
        // }
        dtable.editCell(record.id, this.firstFocusField);
    }
    // afterSaveError(id, status, response) {
    // 	webix.message(reponse.message);
    // }
    ready() {
        let me = this;
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "button-add":
                    me.ajouter();
                    break;
                case "button-del":
                    me.supprimer();
                    break;
            }
        });
        menu.hideMenuItem("button-del");
        menu.hideMenuItem("button-add");
        if ((globals_1.lv2.droits).includes(this.moduleName + ".create,")) {
            menu.showMenuItem("button-add");
        }
        if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,")) {
            menu.showMenuItem("button-del");
        }
        // gestion des erreurs
        let dp = webix.dp(this.datatableName);
        dp.attachEvent("onAfterSaveError", function (id, status, response) {
            webix.alert({
                text: (response.message),
                modal: true
            }).then(function () {
                if (response.rule == 100) {
                    me.currentGrid.getItem(id).email = "";
                    me.currentGrid.editCell(id, "email");
                }
                if (response.rule == 101) {
                    me.currentGrid.getItem(id).nomCourt = "";
                    me.currentGrid.editCell(id, "nomCourt");
                }
            });
        });
        // nettoyage de tous les champs texte
        this.currentGrid.attachEvent("onBeforeEditStop", function (state, editor, ignore) {
            let textFields = ["lieu", "animateur", "vitesse"];
            if (textFields.includes(editor.column)) {
                state.value = globals_1.lv2.verifTexte(state.value);
                return;
            }
        });
    }
}
exports.default = Activites;
